import React, { Suspense, lazy } from 'react';
import Navbar from '@/components/trinity/Navbar';
import Footer from '@/components/trinity/Footer';
import Hero from '@/components/trinity/Hero';
const InternalLinksSection = lazy(() => import('@/components/trinity/InternalLinksSection'));
import PageSEO from '@/components/PageSEO';
import { getPageContent } from '@/lib/seo/pageContent';
import { dentistSchema, breadcrumbSchema, faqSchema, combineSchemas } from '@/lib/seo/schemas';

import { homeFaqs } from '@/lib/seo/homeFaqs';
import useAfterFirstPaint from '@/components/hooks/useAfterFirstPaint';

// All below-the-fold sections ship as one chunk (see HomeBody) so the page
// makes a single request for them instead of eight parallel ones.
const HomeBody = lazy(() => import('@/components/home/HomeBody'));
const AccessibilityWidget = lazy(() => import('@/components/accessibility/AccessibilityWidget'));

export default function Home() {
  // Below-the-fold sections mount one frame after the hero has painted (see
  // useAfterFirstPaint); until then a viewport-tall spacer keeps the footer
  // from sitting next to the hero and shifting when the sections arrive.
  const afterPaint = useAfterFirstPaint();
  const seo = getPageContent('/');
  const jsonLd = combineSchemas(
    dentistSchema,
    faqSchema(homeFaqs),
    breadcrumbSchema([{ name: 'Home', path: '/' }])
  );

  return (
    <div className="min-h-screen bg-white">
      <PageSEO
        title={seo.title}
        description={seo.description}
        path="/"
        ogImage="https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/697e88817b05b4051a928e3f/97657042f_33363942_975460192617351_6697685401403916288_o.jpg"
        jsonLd={jsonLd} />
      
      <Navbar />
      <main>
        <Hero />
        {afterPaint ? (
          <Suspense fallback={null}>
            <HomeBody />
          </Suspense>
        ) : (
          <div aria-hidden="true" style={{ minHeight: '100vh' }} />
        )}
        <div className="w-full">
          







          
          
        </div>
      </main>
      {afterPaint && (
        <Suspense fallback={null}>
          <InternalLinksSection />
        </Suspense>
      )}
      <Footer />
      {afterPaint && (
        <Suspense fallback={null}>
          <AccessibilityWidget />
        </Suspense>
      )}
    </div>);

}